import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { slideToggle } from './../../composables/slideToggle.js';
import { Icon } from '@iconify/react';
import { AppSettings } from './../../config/app-settings.js';
import PerfectScrollbar from 'react-perfect-scrollbar';

function Header() {
	const { appThemePanelToggled, setAppThemePanelToggled } = useContext(AppSettings);
	const userData = {
		img: '/assets/img/user/profile.jpg',
		name: 'USERNAME@GMAIL.COM'
	};
	const chatData = [
		{ msg: ['Hey, I\'m testing out group messaging.'], name: 'Roberto Lambert', img: '/assets/img/user/user-2.jpg' }, 
		{ msg: ['Cool'], reply: true, time: 'Read 16:26' }, 
		{ date: 'Today 14:21' }, 
		{ msg: ['Awesome! What\'s new?'], name: 'Rick Powell', img: '/assets/img/user/user-3.jpg' }, 
		{ msg: [
				'Not much, It\'s got a new look, contact pics show up in group messaging, some other small stuff.',
				'How\'s crusty old iOS 6 treating you?'
			], name: 'Roberto Lambert', img: '/assets/img/user/user-2.jpg'
		},
		{ msg: ['Sucks'], reply: true, time: 'Read 16:30' }
	];
	const calendarData = [{ 
		date: 'TODAY, NOV 4',
		list: [
			{ time_start: '09:00', time_end: '12:00', color: 'bg-success', title: 'Meeting with HR', desc: ['Conference Room'] },
			{ time_start: '20:00', time_end: '23:00', color: 'bg-primary', title: 'Dinner with Richard', desc: ['Tom\'s Too Restaurant'], 
				contact: [{
					name: 'Richard Leong',
					img: '/assets/img/user/user-3.jpg',
					link: '#'
				}]
			},
		]
	}, { 
		date: 'TOMORROW, NOV 5',
		list: [
			{ time_start: 'All day', color: 'bg-gray-300', title: 'Terry Birthday' },
			{ time_start: '08:00', color: 'bg-gray-300', title: 'Meeting' },
			{ time_start: '00:00', time_end: '00:30', color: 'bg-gray-300', title: 'Server Maintenance', desc: ['Data Centre'] }
		]
	}];
	const notificationData = [{
		icon: 'material-symbols-light:mark-email-unread-outline-sharp',
		title: 'New email received',
		desc: 'You have a new email from John Doe.',
		time: '2 minutes ago'
	}, {
		icon: 'material-symbols-light:calendar-clock-outline-sharp',
		title: 'Meeting reminder: Tomorrow at 9:00 AM',
		desc: 'Don\'t forget your meeting with the client.',
		time: '1 hour ago'
	}, {
		icon: 'material-symbols-light:checklist',
		title: 'Task completed',
		desc: 'The task assigned to you has been completed.',
		time: '4 hours ago'
	}, {
		icon: 'material-symbols-light:mark-unread-chat-alt-outline-sharp',
		title: 'New comment on your post',
		desc: 'Someone commented on your recent post.',
		time: '10 hours ago'
	}, {
		icon: 'material-symbols-light:update',
		title: 'System update scheduled',
		desc: 'There will be a system update tomorrow.',
		time: 'Yesterday at 6:00 PM'
	}];
	
	const toggleAppSidebarDesktop = () => {
		var elm = document.querySelector('.app');
		if (elm) {
			if (!(elm.classList.contains('app-with-top-nav') && elm.classList.contains('app-without-sidebar'))) {
				elm.classList.toggle('app-sidebar-collapsed');
				
				setTimeout(() => {
					window.dispatchEvent(new Event('resize'));
				}, 150);
			}
		}
	}
	
	const toggleAppSidebarMobile = () => {
		var elm = document.querySelector('.app');
		if (elm) {
			if (!(elm.classList.contains('app-with-top-nav') && elm.classList.contains('app-without-sidebar'))) {
				elm.classList.toggle('app-sidebar-mobile-toggled');
			} else {
				slideToggle(document.querySelector('.app-top-nav'));
			}
		}
	}
	
	const toggleAppHeaderSearch = () => {
		var elm = document.querySelector('.app');
		elm.classList.toggle('app-header-menu-search-toggled');
	}
	
	const toggleAppThemePanel = (event) => {
		event.preventDefault();
		
		var state = (appThemePanelToggled === 'true' || appThemePanelToggled === true) ? false : true;
		
		setAppThemePanelToggled(state);
		if (localStorage) {
			localStorage.setItem('appThemePanelToggled', state);
		}
	}

	return (
		<div id="header" className="app-header">
			<div className="desktop-toggler">
				<button type="button" className="menu-toggler" onClick={toggleAppSidebarDesktop}>
					<span className="bar"></span>
					<span className="bar"></span>
				</button>
			</div>
			
			<div className="mobile-toggler">
				<button type="button" className="menu-toggler" onClick={toggleAppSidebarMobile}>
					<span className="bar"></span>
					<span className="bar"></span>
				</button>
			</div>
			
			<div className="brand" style={{width: '18rem'}}>
				<Link to="/" className="brand-logo w-100">
					<Icon icon="lets-icons:time-progress-duotone" className="fs-24px me-2 text-theme" />
					<span className="brand-text fw-500 fs-14px">BIBLIOTECA DE SETUPS</span>
				</Link>
			</div>
			
			<div className="menu">
				
		
			</div>
			
			
		</div>
	)
}

export default Header;
